import React, { useEffect, useState, useMemo } from 'react';
import { getTodaysDateUnformatted } from '../../Utils/utils';
import { KodplanProvider } from './Context/KodplanContext';
import type { kodplaner_ekkodplaner as IKodplan } from './Queries/_QueryTypes/kodplaner';
import KodplanManagerQuery from './Queries/KodplanManagerQuery';
import { take } from 'ramda';

interface IProps {}

interface IInnerProps extends IProps {
  kodplaner: IKodplan[] | null;
  loading: boolean;
}

export const getTodaysKodplan = (
  kodplaner: IKodplan[] | null
): IKodplan | undefined => {
  const todaysDate = getTodaysDateUnformatted();
  const year = take(4);
  if (kodplaner == null) {
    return undefined;
  }

  const active = kodplaner.find(
    kodplan =>
      year(kodplan.frombokfar) <= year(todaysDate) &&
      year(kodplan.tombokfar) >= year(todaysDate)
  );

  return active;
};

const KodplanManager: React.FunctionComponent<
  React.PropsWithChildren<IInnerProps>
> = props => {
  const { kodplaner, loading } = props;
  const [activeKodplan, setActiveKodplan] = useState(
    getTodaysKodplan(props.kodplaner)
  );
  useEffect(() => {
    setActiveKodplan(getTodaysKodplan(kodplaner));
  }, [kodplaner]);

  const kodplanContext = useMemo(() => {
    const availableKodplanList = kodplaner != null ? kodplaner : [];

    return {
      loading: loading,
      activeKodplan: activeKodplan,
      availableKodplanList,
      setActiveKodplan: setActiveKodplan,
    };
  }, [kodplaner, loading, activeKodplan]);
  return (
    <KodplanProvider value={kodplanContext}>{props.children}</KodplanProvider>
  );
};

const EnhancedKodplanManager: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => (
  <KodplanManagerQuery>
    {({ kodplaner: kodplanerList, loading }) => {
      return (
        <KodplanManager
          kodplaner={kodplanerList}
          loading={loading}
          {...props}
        />
      );
    }}
  </KodplanManagerQuery>
);

export { IKodplan };
export default EnhancedKodplanManager;
